import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import moments from 'moment-timezone';
import toastr from 'helpers/toastr';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as holidayAction from 'actions/holiday';
import { Segment } from 'semantic-ui-react';
import HolidayHeader from './HolidayHeader';
import HolidayModifyResult from './HolidayModifyResult';
import HolidaySaveModal from './Modal/HolidaySaveModal';
import HolidayBottom from './HolidayBottom';

moments.tz.setDefault('Asia/Seoul');

const propTypes = {
  onSearch: PropTypes.func.isRequired,
  holidayList: PropTypes.arrayOf(PropTypes.any).isRequired,
  holidayAPI: PropTypes.objectOf(PropTypes.func).isRequired,
  holiday: PropTypes.objectOf(PropTypes.any),
  pending: PropTypes.bool
};

const defaultProps = {
  pending: false,
  holiday: {
    data: {
      content: null
    }
  }
};

class HolidayModify extends Component {
  constructor(props) {
    super(props);
    const { holidayList } = props;

    this.state = {
      localIdx: 0,
      item: null,
      holidays: holidayList,
      open: false
    };
  }

  loadHoliday = async (idx) => {
    const { holidayAPI } = this.props;
    if (!idx) {
      return;
    }
    try {
      await holidayAPI.getHoliday(idx);
    } catch (e) {
      const { response } = e;
      if (response) {
        toastr('top-right', 'error', response.data.message);
      }
    }
  };

  moveHoliday = () => {
    const { history } = this.props;
    history.goBack();
  };

  save = async () => {
    // eslint-disable-next-line no-restricted-globals
    if (!confirm('수정된 내용은 저장 즉시 반영됩니다. 수정한 공휴일 설정을 저장하시겠습니까?')) {
      return;
    }

    const {
      holidayAPI,
      onSearch,
      match: {
        params: { id }
      }
    } = this.props;
    const { holidays } = this.state;
    const data = {
      year: id,
      holidayCompanyInfoList: holidays.map((item) => {
        const { idx } = item;
        if (String(idx).match(/local/i)) {
          return {
            ...item,
            idx: null
          };
        }
        return item;
      })
    };
    try {
      await holidayAPI.saveHoliday(data);
      toastr('top-right', 'success', '저장 되었습니다.');
      await onSearch(id);
      this.moveHoliday();
    } catch (e) {
      const { response } = e;
      if (response) {
        toastr('top-right', 'error', response.data.message);
      }
    }
  };

  handleChangeIsActive = (item) => {
    const { isActive } = item;
    this.updateRow({ ...item, ...{ isActive: !isActive } }, true);
  };

  dateUpdateValidation = (startDate, endDate) => {
    const today = moment();
    const isBeforeStartDate = moment(startDate).isBefore(today);
    const isBeforeEndDate = moment(endDate).isBefore(today);
    if (isBeforeStartDate || isBeforeEndDate) {
      alert('금일이거나, 이전 날짜의 공휴일은 수정하실 수 없습니다.');
      return false;
    }
    return true;
  };

  openModal = async (item) => {
    // item이 있으면 수정
    if (item) {
      const { idx, startDate, endDate, itemStatus } = item;

      if (!this.dateUpdateValidation(startDate, endDate)) {
        return false;
      }
      // 로컬 변경 사항인지 확인
      if ((idx && idx.toString().match(/local/i)) || itemStatus === 'updated') {
        this.setState({ item, open: true });
      } else {
        await this.loadHoliday(idx);
        const {
          holiday: {
            data: { content }
          }
        } = this.props;
        this.setState({ item: content, open: true });
      }
    } else {
      // 공휴일 추가
      this.setState({ open: true, item: null });
    }
    return true;
  };

  closeModal = (result) => {
    this.setState({ open: false });

    // 없으면 취소
    if (!result) {
      return;
    }

    const { operation, item } = result;
    if (operation === 'add') {
      this.addRow(item);
    } else if (operation === 'addAndContinue') {
      this.addRow(item);
      this.setState({ open: true });
    } else {
      this.updateRow(item);
    }
  };

  addRow = (item) => {
    const { holidays } = this.state;
    let { localIdx } = this.state;
    localIdx += 1;
    const idx = `local${localIdx}`;
    holidays.push({ ...item, ...{ idx, updatable: true, deletable: true, itemStatus: 'new' } });
    this.setState({
      localIdx,
      holidays
    });
  };

  updateRow = (item, isOtherMethodCall) => {
    const { holidays } = this.state;
    let itemStatus = {};
    if (!isOtherMethodCall) {
      itemStatus = { itemStatus: 'updated' };
    }
    this.setState({
      holidays: holidays.map((e) => (e.idx === item.idx ? { ...e, ...item, ...itemStatus } : e))
    });
  };

  deleteRow = (item) => {
    const { startDate, endDate } = item;

    if (!this.dateUpdateValidation(startDate, endDate)) {
      return;
    }

    // eslint-disable-next-line no-restricted-globals
    if (!confirm('해당 공휴일을 삭제하시겠습니까?')) {
      return;
    }
    const { holidays } = this.state;
    const { idx } = item;
    // 로컬 변경은 삭제
    if (idx.toString().match(/local/i)) {
      this.setState({
        holidays: holidays.filter((e) => e.idx !== item.idx)
      });
    } else {
      this.updateRow({ ...item, ...{ isDelete: true, itemStatus: 'deleted' } }, true);
    }
  };

  render() {
    const {
      pending,
      match: {
        params: { id }
      }
    } = this.props;
    const { holidays, open, item } = this.state;

    return (
      <div className="si">
        <Segment vertical>
          <HolidayHeader value={id} header="modify" onAdd={this.openModal} />
        </Segment>
        <HolidayModifyResult
          holidays={holidays}
          handleChange={this.handleChangeIsActive}
          onUpdate={this.openModal}
          onDelete={this.deleteRow}
        />
        <Segment vertical>
          <HolidayBottom loading={pending} onMovePage={this.moveHoliday} onSave={this.save} />
        </Segment>
        <HolidaySaveModal item={item} year={id} open={open} close={this.closeModal} />
      </div>
    );
  }
}

HolidayModify.propTypes = propTypes;
HolidayModify.defaultProps = defaultProps;

export default connect(
  (state) => ({
    holiday: state.holiday.holidayCompanyInfo,
    pending: state.holiday.isSavePending
  }),
  (dispatch) => ({
    holidayAPI: bindActionCreators(
      {
        getHoliday: holidayAction.HolidayCompanyInfo,
        saveHoliday: holidayAction.HolidayCompanySave
      },
      dispatch
    )
  })
)(HolidayModify);
